<card-form #cardFormTemplate
           *ngIf="formConfig && formConfig.formGroup"
           [options]="formConfig"
           (isError)="displayErrors()"
           (onSubmit)="onFormSubmitTraveller(form)"
           (keyup)="getTravellerInformations(form)"
           (click)="getTravellerInformations(form)">
    <div class="card-header-content">
        <h1 [ngPlural]="(travellerItem | keys).length">
            <ng-template ngPluralCase="=1">{{wording.traveller}}</ng-template>
            <ng-template ngPluralCase="other">{{(travellerItem | keys).length}} {{wording.travellers}}</ng-template>
        </h1>
        <div class="btn-right">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="card-body-content">
        <notification [type]="apisNotification.type" *ngIf="apisNotification.active">{{apisNotification.message}}</notification>
        <ng-container #traveller>
            <traveller-fieldset #travellerFieldsetComponent
                                [apisForm]="useApis"
                                [nbItems]="nbItems"
                                [group]="form.controls.traveller"
                                [disableTypes]="disableTypes"
                                [config]="config.traveller"
                                [ageLimitConfig]="ageLimitConfig"
                                [travellerItem]="travellerItem"
                                [columns]="columns"
                                [contextIsModifySegment]="contextIsModifySegment"
                                [apiServiceQualityMessage]="apiServiceQualityMessage"
                                [validators]="validators"></traveller-fieldset>
        </ng-container>
    </div>
</card-form>
